$(document).on("turbo:load", () => {
  const googleOneTap = document.querySelector("#g_id_onload");

  // Timezone handling logic
  const timezone = window.Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;

  if (timezone) {
    const timezoneInput = $("input.timezone[data-default-from-locale]");
    if (timezoneInput.length > 0) {
      timezoneInput.val(timezone);
    }

    if (googleOneTap) {
      googleOneTap.dataset.time_zone = timezone;
      if (window.google) {
        window.google.accounts.id.prompt();
      }
    }
  }

  // Marketing emails checkbox handling logic
  const checkbox = $("#user_subscribed_to_marketing_emails");
  const hiddenFields = $(".sso_signup_form_marketing_emails_hidden");

  if (checkbox.length && hiddenFields.length) {
    function updateHiddenFields() {
      const isChecked = checkbox.prop("checked") ? "1" : "0";
      hiddenFields.each(function() {
        $(this).val(isChecked);
      });

      if (googleOneTap) {
        googleOneTap.dataset.marketing_optin = isChecked;
        if (window.google) {
          window.google.accounts.id.prompt();
        }
      }
    }

    checkbox.on("change", updateHiddenFields);
    updateHiddenFields();
  }
});
